export let routes = [
  {
    path: '/x3-side-permission',
    name: 'x3-side-permission',
    component: () => import('@x3/js/side/permission/permission.vue'),
    meta: {
      vx_animate: 'none',
    },
  },
];

export let api = {
  permission(options) {
    return new Promise((resolve, reject) => {
      app.router.push(
        '/x3-side-permission',
        route => {
          route.meta._resolve = resolve;
          route.meta._reject = reject;
          route.meta.options = options;
        },
        err => {
          console.log(err);
        }
      );
    });
  },
};
